module.exports = __webpack_public_path__ + "assets/img/2518263de7f9e1f20ab8d64bc898afae.svg";